import { MessageSquare } from "lucide-react";
import { Container, IconContainer, Message } from "./styles";
import { comum } from "../../../../styles/Themes/light";

interface EmptyStateProps {
    message?: string;
}

export default function EmptyState({ message = "Nenhum comentário disponível" }: EmptyStateProps) {
    return (
        <Container role="status" aria-live="polite">
            <IconContainer>
                <MessageSquare size={32} color={comum.colors.interfaceGray500} />
            </IconContainer>
            <Message>{message}</Message>
        </Container>
    );
}




